import React from "react";

const WhatsappIcon = () => {
  return (
    <>
      <div className="whatsapp_float">
        <a href="https://wa.me/917240954834" target="_blank">
          <img
            src="./WhatsappLogo_1.gif"
            width="50px"
            className="whatsapp_float_btn"
          />
        </a>

      </div>
    </>
  );
};

export default WhatsappIcon;
